var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_1536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3534 11.1931H25.0916L30.4606 24.6158L23.7493 28.6426C26.6243 34.4721 31.3424 39.1902 37.1719 42.0652L41.1987 35.3539L54.6214 40.7229V51.4611C54.6214 52.885 54.0557 54.2507 53.0488 55.2576C52.0419 56.2644 50.6763 56.8301 49.2523 56.8301C38.7807 56.1938 28.904 51.747 21.4858 44.3287C14.0675 36.9105 9.62074 27.0338 8.98438 16.5622C8.98438 15.1382 9.55004 13.7726 10.5569 12.7657C11.5638 11.7588 12.9295 11.1931 14.3534 11.1931",
    stroke: "#3C3C3C",
    strokeWidth: 3.68164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_1536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.4287,
    height: 64.4287,
    fill: "white",
    transform: "translate(0.929688 0.455078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCallIcon);
export default __webpack_public_path__ + "static/media/phone-call-icon.90b18a5698e1ef90afeaa2d803d4e822.svg";
export { ForwardRef as ReactComponent };